import React from "react";
import "./ContestPlayerListDisplay.css";
import { graphql, useLazyLoadQuery } from "react-relay";
import StatTable from "../../../../../StatTable";
import { sortGolfToPars, sortPercentageFloat } from "../../../../../../Utils";

const QUERY = graphql`
  query ContestPlayerListDisplayQuery($contestId: ID!) {
    playersForContest(contestId: $contestId) {
      slatePlayer {
        id
        salary
        player {
          name
        }
        dkPoints
        dkLeaderboardPositionPoints
        isCut
        toPar
        prettyToPar
      }
      percOwned
    }
  }
`;

export default function ContestPlayerListDisplay({ contestId }) {
  const queryData = useLazyLoadQuery(
    QUERY,
    { contestId: contestId },
    { fetchPolicy: "network-only" }
  );

  const data = React.useMemo(() => {
    return queryData.playersForContest.map((playerInfo) => {
      const newPlayer = { ...playerInfo.slatePlayer };

      newPlayer["name"] = newPlayer.player.name;
      newPlayer["dkDiff"] =
        newPlayer.dkPoints - newPlayer.dkLeaderboardPositionPoints;
      newPlayer["cutStatus"] = newPlayer.isCut ? "Yes" : "No";
      newPlayer["percOwned"] = playerInfo.percOwned + "%";

      return newPlayer;
    });
  }, [contestId]);

  const columns = [
    { Header: "To Par", accessor: "prettyToPar", sortType: sortGolfToPars },
    { Header: "Salary", accessor: "salary" },
    { Header: "Player", accessor: "name" },
    { Header: "Cut?", accessor: "cutStatus" },
    {
      Header: "Perc Owned",
      accessor: "percOwned",
      sortType: sortPercentageFloat,
    },
    { Header: "DK Pts", accessor: "dkDiff" },
    { Header: "DK Fin", accessor: "dkLeaderboardPositionPoints" },
    { Header: "DK Total", accessor: "dkPoints" },
  ];

  return (
    <StatTable
      data={data}
      columns={columns}
      showDKPlayerInfo={(p) => {
        console.log(p);
      }}
      paginate={true}
    />
  );
}
